(function(){
  var root = document.querySelector('.cmp');
  if(!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll reveal */
  var rv = root.querySelectorAll('[data-rv]');
  if(reduce || !('IntersectionObserver' in window)){
    rv.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    rv.forEach(function(el){ io.observe(el); });
  }

  /* LED sayaç */
  var counters = root.querySelectorAll('[data-count]');
  function runCount(el){
    var target = parseInt(el.getAttribute('data-count'),10) || 0;
    if(reduce){ el.textContent = target; return; }
    var start = null, dur = 900;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      el.textContent = Math.round(target * (1 - Math.pow(1-p,3)));
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if('IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ runCount(e.target); io2.unobserve(e.target); } });
    }, {threshold:0.4});
    counters.forEach(function(el){ io2.observe(el); });
  } else { counters.forEach(runCount); }

  /* canlı geri sayım */
  var endStr = root.getAttribute('data-end');
  var end = endStr ? new Date(endStr).getTime() : NaN;
  var live = root.querySelector('[data-cmp-live]');
  var ended = root.querySelector('[data-cmp-ended]');
  var cd = {}, lastSec = -1;
  root.querySelectorAll('[data-cd]').forEach(function(el){ cd[el.getAttribute('data-cd')] = el; });
  var daysEl = root.querySelector('[data-days]');
  function pad(n){ return (n<10?'0':'') + n; }
  function tick(){
    if(isNaN(end)) return;
    var diff = end - Date.now();
    if(diff <= 0){
      if(live) live.hidden = true;
      if(ended) ended.hidden = false;
      clearInterval(timer);
      return;
    }
    var s = Math.floor(diff/1000), d = Math.floor(s/86400),
        h = Math.floor(s%86400/3600), m = Math.floor(s%3600/60), sec = s%60;
    if(cd.d) cd.d.textContent = pad(d);
    if(cd.h) cd.h.textContent = pad(h);
    if(cd.m) cd.m.textContent = pad(m);
    if(cd.s){
      cd.s.textContent = pad(sec);
      if(!reduce && sec !== lastSec){
        cd.s.classList.remove('flash');
        void cd.s.offsetWidth;
        cd.s.classList.add('flash');
      }
      lastSec = sec;
    }
    if(daysEl) daysEl.textContent = d;
  }
  tick();
  var timer = setInterval(tick, 1000);

  /* kahraman ürün renk seçici */
  var stage = root.querySelector('[data-stage]');
  var sws = root.querySelectorAll('[data-sw]');
  sws.forEach(function(btn){
    btn.addEventListener('click', function(){
      var i = btn.getAttribute('data-sw');
      sws.forEach(function(b){ b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      if(stage) stage.querySelectorAll('img').forEach(function(img){
        img.classList.toggle('on', img.getAttribute('data-v') === i);
      });
    });
  });
})();
